import { axiosBase, errorHandler } from "./axios";

const getTenantList = (data: any) => {
  return axiosBase
    .get("tenant/list", { params: data })
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const saveTenant = (data: any) => {
  return axiosBase
    .post("tenant/save", data)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const viewTenant = (id: string) => {
  return axiosBase
    .get(`tenant/view/${id}`)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

export const tenantService = {
  getTenantList,
  saveTenant,
  viewTenant,
};
